
import React, { Component, Fragment, useEffect, useState, useContext } from "react";

import BiLabel from '../../uic/controls/BiLabel';



const InfoBoxStranka = ({ stranka }) => {



    return (

        <Fragment >

            {stranka &&


                <div style={{ margin: "5px", border: "1px solid gray", borderRadius: "10px", backgroundColor: "lightyellow", padding: "5px" }} >

                    <table style={{ tableLayout: "fixed", width: "100%" }} >
                        <colgroup>
                            <col style={{ width: "140px" }} ></col>
                            <col style={{ width: "100%" }} ></col>
                        </colgroup>
                        <thead>
                            <tr>
                                <td><BiLabel ><b>Podatki o stranki</b></BiLabel> </td>
                                <td></td>
                            </tr>
                        </thead><tbody>
                            <tr>
                                <td style={{ padding: "5px" }} ></td>
                            </tr>
                            <tr>
                                <td><BiLabel icon="far fa-id-badge">KMG ID:</BiLabel> </td>
                                <td>{stranka.kmgMid}</td>
                            </tr>

                            <tr>
                                <td><BiLabel icon="fas fa-list">Šifra pogodbe:</BiLabel> </td>
                                <td>{stranka.sifPogodbe}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "5px" }} ></td>
                            </tr>
                            <tr>
                                <td><BiLabel icon="far fa-user">Naziv: </BiLabel></td>
                                <td><b>{stranka.naziv}</b></td>
                            </tr>
                            <tr>
                                <td><BiLabel icon="far fa-address-card">Naslov:</BiLabel> </td>
                                <td>{stranka.naslov}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "5px" }} ></td>
                            </tr>
                            <tr>
                                <td><BiLabel icon="fas fa-mobile-screen">GSM:</BiLabel> </td>
                                <td>{stranka.gsm}</td>
                            </tr>
                            <tr>
                                <td><BiLabel icon="fas fa-square-phone">Telefon:</BiLabel> </td>
                                <td>{stranka.telefon}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: "5px" }} ></td>
                            </tr>
                            <tr>
                                <td><BiLabel icon="far fa-calendar">Datum prijave:</BiLabel> </td>
                                <td>{stranka.datumPrijave}</td>
                            </tr></tbody>
                    </table>

                </div>


            }
        </Fragment>
    );

}

export default InfoBoxStranka;